export default {
  state: {
    sesmanUser: {}
  },
  getters: {
    getUser: state => {
      return state.sesmanUser
    }
  },
  actions: {
    setUser (context, userInfo) {
      return new Promise((resolve, reject) => {
        context.commit('setUser', userInfo)
      })
    }
  },
  mutations: {
    setUser (state, userInfo) {
      state.sesmanUser = userInfo
    }
  }
}
